import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { FileService } from '../../shared/services/file.service';
import { SortDirection } from '../../shared/sort-direction';
import { Observable } from 'rxjs';
import { SearchObjectResult } from '../../shared/search-object-result.model';
import * as moment from 'moment';
import { HttpUtils } from '../../shared/http-utils';
import { URL_BASE } from '../../core/constants';
import { flatMap, map } from 'rxjs/operators';
import { AssetSearchCriteria } from './asset-search-criteria.model';
import { Asset } from './asset.model';
import { LogEventSearchCriteria } from '../../log-events/shared/log-event-search-criteria.model';

@Injectable({
  providedIn: 'root'
})
export class AssetService {

  private ASSETS_URI = 'assets';

  constructor(private http: HttpClient, private fileService: FileService) {
  }

  public search(
    page: number, size: number, sortColumn: string, direction: SortDirection, criteria: AssetSearchCriteria
  ): Observable<SearchObjectResult<Asset>> {
    for (const key of Object.keys(criteria)) {
      if (!criteria[key]) {
        delete criteria[key];
      }
    }

    const headers = HttpUtils.createHeaders();
    const params  = {
      page: String(page),
      size: String(size),
      sort: sortColumn,
      direction: direction,
      ...criteria
    };
    const url     = `${URL_BASE}/api/${this.ASSETS_URI}/search`;
    return this.http.get(url, { headers, params })
      .pipe(
        map(result => SearchObjectResult.fromDto(result, Asset.fromDto))
      );
  }

  public exportAssets(criteria: LogEventSearchCriteria): Observable<void> {
    for (const key of Object.keys(criteria)) {
      if (!criteria[key]) {
        delete criteria[key];
      }
    }

    const headers = HttpUtils.createHeaders();
    headers.set('Accept', 'text/plain');
    const params = {
      ...criteria
    };

    const url = `${URL_BASE}/api/${this.ASSETS_URI}/export`;

    return this.http.get(url, { headers, params, responseType: 'blob', observe: 'response' })
      .pipe(
        flatMap((response: HttpResponse<Blob>) => this.fileService.saveToFileSystem(response))
      );
  }
}
